import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setBankDataActions,
  SetActiveTabs,
  setBankDataCreateActions,
  setBankDataEditActions,
  setTheActionsFroTheBankPassbooks,
  SetEducationDetails, ///education details
  SetActionsBasicFormsDetails,
  BankVerifyActions,
  CreateTokenForBankVerifyActions,
  setbankCounts,
  CreateResponse_store,
  setTheTransactionID,
  settheBankHolderName,
  setTheBankNameVerification,
  SetCasualActiveTabs,
  setCasualFormUpdateActions,
} from "../../../Redux/Slice";
import { Grid, Typography } from "@material-ui/core";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ImageCropper from "../ReactcropOverall/Imagecrop";

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Title } from "chart.js";
import banknotVerifed from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-17 (1).svg";

import BankAsVerifyed from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-16.svg";
import { PresentUrl } from "../../../text/apidata";
import axios from "axios";
import { store } from "../../../Redux/Store";
import { Downloads_doc } from "../FormDetails/Downloads_doc";

const CasualBankDetails = (props) => {
  const { propsID } = props;
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const isUploadingRef = useRef(false);
  const formdata = new FormData();
  const [file, setImageField] = useState([]);
  const [ImageFieldUrl, setImageFieldurl] = useState({ frontImage: "" });
  const [BankImageCAnUplo, setBankUplo] = useState(false);
  const [PasChec, setPassChe] = useState({ cheque: false, passbook: true });
  const passBookFormdata = new FormData();
  const [count, setCount] = useState(0); // Initialize count with one_mark
  const [validateed, setValidated] = useState(0);
  const [NameVlidation, setnameValidation] = useState(0);
  const [isBankVerified, setIsBankVerified] = useState(false);
  const Navigate = useNavigate();
  ///---present---url
  const [PresentUrls, setPresentUrls] = useState([]);
  const [presenturlInUrl, seturlandfile] = useState({
    file: "",
    url: "",
  });

  const incrementCount = () => {
    setCount(count + 1);
  };
  const Swal = require("sweetalert2");

  useEffect(() => {
    if (
      state.FormsIDList.BankDetailID != "" &&
      state.FormsIDList.ActiveTabs == 4
    ) {
      let payload = {
        Retieveid: state.FormsIDList.BankDetailID,
      };
      // dispatch(SetActionsBasicFormsDetails(payload));
      dispatch(setBankDataActions(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);
  const [Bankfile, setbankfile] = useState();
  var bankval;
  const initialState = {
    account_holder_name: "",
    bank_name: "",
    account_number: "",
    ifsc_code: "",
    bank_branch: "",

    timeline_id: state.BasicFormCreated.BasciFormCreate,

    is_bank_details: false,
    bank_count: 0,
    bank_transaction_id: "",
    account_exists: false,
    remarks: "",

    // timeline_id: state.EmployeeProfile.EmployeeProfileList.id,
  };
  const [data, setDatas] = useState(initialState);
  const [accountNameErr, setAcNameErr] = useState("");
  const [accountName, setAccountName] = useState("");
  const [AcNumberErr, setAccNumErr] = useState("");
  const [BankNaErr, setBankErr] = useState("");
  const [IFSErr, setIfsErr] = useState("");
  const [banckImgeErr, setBankimgErr] = useState("");
  const [bankBranchErr, setBankBranchErr] = useState("");
  const [url, setUrl] = useState();
  const [alert, setalert] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [imgsrc, setImgsrc] = useState();
  const imgRef = useRef(null);
  const [PhoneNumber, setPhoneNumber] = useState({ phone_number: "" });
  const [phoneErr, setPhoneErr] = useState();
  const [whatsApp, setWhatsApp] = useState(false);
  const [Bankimgsupload, setbankImgUpload] = useState(false);
  // var IsBankVerified = false;
  const [crop, setCrop] = useState();
  const [Croped, setCroped] = useState(false);
  const editform = new FormData();
  const editform2 = new FormData();
  const form2 = new FormData();

  var PennyDropVerification = state.pennydropforBank.BankVerify;
  const fixedCropSize = { width: 300, height: 200 };
  const [NameState, setNameState] = useState("");

  const fileInputRef = useRef();
  const [EmailID, setEmailID] = useState("");
  const UserData = useSelector((state) => state.users.UserData.data);

  useEffect(() => {
    if (UserData != undefined) {
      if (
        UserData.admin_access != undefined &&
        UserData.admin_access != "" &&
        UserData.admin_access != null &&
        UserData.admin_access != undefined
      ) {
        console.log(UserData.email, "927309UserData");
        setEmailID(UserData.email);
      }
    }
  }, [state.users.UserData.data]);

  useEffect(() => {
    if (state.FormsIDList.ActiveTabs == 4) {
      setNameState(
        state.FormsIDList.BankDetailID == ""
          ? state.NumberCounts.FirstName.toUpperCase() !==
            data.account_holder_name.toUpperCase()
            ? true
            : false
          : state.FormsIDList.BankDetailID != "" &&
            state.BankDetails.Bankdata.account_holder_name != undefined &&
            state.BankDetails.Bankdata.account_holder_name != null &&
            state.pennydropforBank.Bank_Holder_Name != "" &&
            state.pennydropforBank.Bank_Holder_Name.toUpperCase() !=
            state.BankDetails.Bankdata.account_holder_name.toUpperCase()
            ? true
            : false,
      );
      //  console.log(state.NumberCounts.FirstName ,"check",data.account_holder_name , "data.account_holder_name",

      //   state.NumberCounts.FirstName.toUpperCase() !==
      // data.account_holder_name.toUpperCase() ? true : false
      //   );

      dispatch(
        setTheBankNameVerification(
          state.FormsIDList.BankDetailID == ""
            ? state.NumberCounts.FirstName.toUpperCase() !==
              data.account_holder_name.toUpperCase()
              ? true
              : false
            : state.FormsIDList.BankDetailID != "" &&
              state.BankDetails.Bankdata.account_holder_name != undefined &&
              state.BankDetails.Bankdata.account_holder_name != null &&
              state.pennydropforBank.Bank_Holder_Name != "" &&
              state.pennydropforBank.Bank_Holder_Name.toUpperCase() !=
              state.BankDetails.Bankdata.account_holder_name.toUpperCase()
              ? true
              : false,
        ),
      );
    }
  }, [
    state.NumberCounts.FirstName,
    state.pennydropforBank.Bank_Holder_Name,
    state.FormsIDList.BankDetailID,
    state.FormsIDList.ActiveTabs,
    state.BankDetails.Bankdata,
  ]);

  const cancel = (e) => {
    isUploadingRef.current = false;
    setalert(true);

    setImageField("");
    setUrl("");
    setbankImgUpload(false);
    setBankUplo(false);

    seturlandfile({
      url: "",
    });

    // Reset fields
    setAccountName("");
    setDatas({
      account_holder_name: "",
      account_number: "",
      bank_branch: "",
      bank_name: "",
      ifsc_code: "",
    });

    setIsBankVerified(false);

    // Reset validation errors
    setAcNameErr("");
    setBankErr("");
    setBankBranchErr("");
    setIfsErr("");
    setAccNumErr("");
    setPhoneErr("");
  };

  const style = {
    color:
      state.pennydropforBank.BankVerify != [] &&
        state.pennydropforBank.BankVerify == true
        ? "green"
        : "#ddd",
    fontSize: "24px",
    fontWeight: "900",
  };

  useEffect(() => {
    if (
      url &&
      !CroppImageView &&
      state.UpdateDatafromChequeOrPassbook.DataAsEncoded != undefined &&
      state.UpdateDatafromChequeOrPassbook.DataAsEncoded != null &&
      state.UpdateDatafromChequeOrPassbook.DataAsEncoded &&
      // BankImageCAnUplo &&
      state.UpdateDatafromChequeOrPassbook?.DataAsEncoded?.length > 0
    ) {
      const joinedString =
        state.UpdateDatafromChequeOrPassbook.DataAsEncoded.join("");
      if (joinedString && isUploadingRef.current) {
        const parsedJson = JSON.parse(joinedString);
        console.log(parsedJson, "parsedJson");
        if (joinedString) {
          if (parsedJson.data) {
            if (parsedJson.data.text) {
              const innerJsonString = parsedJson.data.text;
              const innerParsedJson = JSON.parse(innerJsonString);
              // console.log(innerParsedJson, "innerParsedJson", AcholName);

              if (innerParsedJson) {
                setDatas({
                  ...data,
                  account_holder_name:
                    innerParsedJson?.name != null
                      ? innerParsedJson.name.toUpperCase()
                      : "",
                  bank_name:
                    innerParsedJson?.bankName != null
                      ? innerParsedJson.bankName.toUpperCase()
                      : "",
                  account_number:
                    innerParsedJson?.accountNumber != null
                      ? innerParsedJson.accountNumber
                      : "",
                  ifsc_code:
                    innerParsedJson?.ifsc != null
                      ? innerParsedJson.ifsc.toUpperCase()
                      : "",
                  bank_branch:
                    innerParsedJson?.branch != null
                      ? innerParsedJson.branch.toUpperCase()
                      : "",
                });

                dispatch(
                  settheBankHolderName(
                    innerParsedJson?.name != null
                      ? innerParsedJson.name.toUpperCase()
                      : "",
                  ),
                );
              }
            } else if (!parsedJson.data.text) {
              const innerJsonString = parsedJson.data;
              console.log(parsedJson, "8969parsedJson");
              // const innerParsedJson = JSON.parse(innerJsonString);
              const innerParsedJson = innerJsonString;
              // console.log(innerParsedJson, "o3475834innerParsedJson", AcholName);

              // if (innerParsedJson) {
              //   setDatas({
              //     ...data,
              //     account_holder_name:
              //       innerParsedJson?.name != null
              //         ? innerParsedJson.name.toUpperCase()
              //         : "",
              //     bank_name:
              //       innerParsedJson?.bank_name != null
              //         ? innerParsedJson.bank_name.toUpperCase()
              //         : "",
              //     account_number:
              //       innerParsedJson?.account_number != null
              //         ? innerParsedJson.account_number
              //         : "",
              //     ifsc_code:
              //       innerParsedJson?.ifsc != null
              //         ? innerParsedJson.ifsc.toUpperCase()
              //         : "",
              //     bank_branch:
              //       innerParsedJson?.branch_name != null
              //         ? innerParsedJson.branch_name.toUpperCase()
              //         : "",
              //   });
              // }
            }
          }
          if (parsedJson && state.FormsIDList.ActiveTabs == 4) {
            // console.log(parsedJson.status, "78709parsedJson");
            if (Bankimgsupload == true && parsedJson.status) {
              if (
                parsedJson.status !== undefined &&
                parsedJson.status !== null
              ) {
                if (parsedJson.status === "failure") {
                  // Check if parsedJson.data and parsedJson.data.status.message exist
                  const errorMessage =
                    parsedJson.message || "An error occurred";
                  toast.error(` ${errorMessage} `, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                }
                if (parsedJson.status == "success" && parsedJson.data != null) {
                  if (parsedJson.data.text && parsedJson.data.text === "{}") {
                    toast.error(` ${"Please upload the valid image"} `, {
                      position: toast.POSITION.TOP_RIGHT,
                    });
                  } else {
                    toast.success(`Bank verified successfully `, {
                      position: toast.POSITION.TOP_RIGHT,
                    });
                  }
                }
              }
            }
          }
        }
      }
    }
  }, [
    url,
    Bankimgsupload,
    BankImageCAnUplo,
    CroppImageView,
    state.UpdateDatafromChequeOrPassbook,
    state.UpdateDatafromChequeOrPassbook.DataAsEncoded,
  ]);
  //  console.log(state.FormsIDList.BankDetailID , "state.FormsIDList.BankDetailID");

  useEffect(() => {
    if (
      state.FormsIDList.BasicFormID != undefined &&
      state.FormsIDList.ActiveTabs == 4
    ) {
      let payload = {
        Retieveid: state.FormsIDList.BasicFormID,
      };
      dispatch(SetActionsBasicFormsDetails(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);

  // console.log(state.FormsSDETAILS.BasciForm.id , "203740237");
  useEffect(() => {
    if (
      state.FormsSDETAILS.BasciForm.id != undefined &&
      state.FormsIDList.BasicFormID == state.FormsSDETAILS.BasciForm.id &&
      state.FormsIDList.BasicFormID != ""
    ) {
      setPhoneNumber({
        ...PhoneNumber,
        phone_number: state.FormsSDETAILS.BasciForm.phone_number,
      });
    }
  }, [state.FormsSDETAILS.BasciForm]);

  ////---PassBook-------or -------------cheque----changes---
  const handlePassBookChnages = (e, name, value, values) => {
    // console.log(value, "skabfiasdiuasib d", PasChec);
    setPassChe({
      ...PasChec,
      cheque: value,
      passbook: values,
    });
  };
  const HandleChanges = (e) => {
    setDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value.toUpperCase(),
      };
    });
  };

  //  console.log(CroppImageViewCount , "CroppImageViewCount");
  function getCroppedImg(imageRef, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        const croppedFile = new File([blob], fileName, {
          type: "image/jpeg",
        });
        var file = croppedFile;
        if (CroppImageViewCount == 1) {
          if (croppedFile) {
            setTimeout(() => {
              setCroppImageView(false);
            }, 0);

            const generateRandomNumber = (digits = 12) => {
              const min = 10 ** (digits - 1);
              const max = 10 ** digits;
              return Math.floor(min + Math.random() * (max - min));
            };

            const createPresentData = (croppedFile) => {
              const randomNumber = generateRandomNumber();
              const formattedFilename = `onboarding/bank/bank${randomNumber}.${croppedFile.type.split("/")[1]}`; // Use the file's extension
              const Presentdata = {
                multiple_files: [
                  {
                    filename: formattedFilename,
                    file_type: croppedFile.type,
                  },
                ],
              };

              return Presentdata;
            };

            const Presentdata = createPresentData(croppedFile);

            axios({
              url: PresentUrl,
              method: "post",
              data: Presentdata,
              headers: {
                Authorization:
                  "Bearer " + store.getState().users.UserData.session.token,
              },
            })
              .then((response) => {
                console.log("Files uploaded successfully:", response.data);
                const uploadedFiles = response.data.data;
                const newUrls = uploadedFiles.map((file) => ({
                  url: file,
                  type: croppedFile.type,
                  putfiles: croppedFile,
                }));

                // Update PresentUrls state
                setPresentUrls((prevUrls) => [...prevUrls, ...newUrls]);
                seturlandfile({
                  url: String(response.data.data).split("?")[0],
                });
              })
              .catch((error) => {
                console.error("Error uploading files:", error);
              });
          }

          setImageField((oldArray) => [...oldArray, croppedFile]);
          var file = croppedFile;
          var reader = new FileReader();

          reader.onloadend = function () {
            setUrl(reader.result);
          };
          reader.readAsDataURL(file);
        }
        resolve(croppedFile);
      }, "image/jpeg");
    });
  }

  const selectedImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      console.log(imgsrc, "imgsrc");
    }
  };

  const setCompletedCrop = async (c) => {
    console.log(c, "newfile.jpeg", imgRef.current);
    const url = await getCroppedImg(imgRef.current, c, "newfile.jpeg");
  };
  const onImageLoaded = (image) => {
    // imgRef = image;
    imgRef.current = image;
  };

  const handleFiles = (e) => {
    isUploadingRef.current = true;
    setBankUplo(true);
    setPresentUrls([]);
    // selectedImage(e);
    setbankfile(e);
    setbankImgUpload(true);
    setCroppImageViewCount(1);
    setCroppImageView(true);
    setalert(true);

    const file = e.target.files[0];
    console.log(e.target.files[0], "2394827398792873");
    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const maxSize = 10 * 1024 * 1024; // 3MB in bytes
    const MIN_DIMENSION = 150;

    // if (file && allowedTypes.includes(file.type)) {
    //   if (file.size > maxSize) {
    //     setCroppImageView(false);
    //     toast.error("File size exceeds 10 MB. Please upload a smaller image.");
    //   } else {
    //     selectedImage(e);

    //     if (e.target.files[0]) {
    //       passBookFormdata.append("bank_id", e.target.files[0]);
    //       //passBook---Calls--=\
    //       const payload = {
    //         passBookFormdata: passBookFormdata,
    //         cheque: PasChec.cheque,
    //         passbook: PasChec.passbook,
    //       };
    //       dispatch(setTheActionsFroTheBankPassbooks(payload)); //----PassBook

    //       // if (
    //       //   state.UpdateDatafromChequeOrPassbook.DataAsEncoded != undefined &&
    //       //   state.UpdateDatafromChequeOrPassbook.DataAsEncoded != null
    //       // ) {

    //       // }
    //     }

    //   }
    // } else {
    //   setCroppImageView(false);
    //   toast.error("Please upload an image file (jpg, jpeg, png, svg).");
    // }

    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        setCroppImageView(false);
        toast.error("File size exceeds 10MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const imageElement = new Image();
          const imageUrl = reader.result?.toString() || "";
          imageElement.src = imageUrl;

          imageElement.addEventListener("load", (imgEvent) => {
            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
              toast.error("Image must be at least 150 x 150 pixels.");
              setCroppImageView(false);
              return;
            }
            selectedImage(e);

            passBookFormdata.append("bank_id", e.target.files[0]);
            //passBook---Calls--=\
            const payload = {
              passBookFormdata: passBookFormdata,
              cheque: PasChec.cheque,
              passbook: PasChec.passbook,
            };
            dispatch(setTheActionsFroTheBankPassbooks(payload)); //----PassBook
          });
        });
        reader.readAsDataURL(file); // Read the file as a data URL
      }
    } else {
      setCroppImageView(false);
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
      // e.target.value = ""; // Clear the file input
    }
  };

  ///----bank---details----
  useEffect(() => {
    if (
      // state.NumberCounts.Editable == 1 &&
      state.EmployeeProfile.EmployeeProfileList != "" &&
      state.EmployeeProfile.EmployeeProfileList != null &&
      state.EmployeeProfile.EmployeeProfileList != undefined &&
      state.EmployeeProfile.EmployeeProfileList.is_bank_details != null &&
      state.EmployeeProfile.EmployeeProfileList.is_bank_details != undefined
    ) {
      setWhatsApp(state.EmployeeProfile.EmployeeProfileList.is_bank_details);
      // setWhatsApp(true);
      console.log(
        state.EmployeeProfile.EmployeeProfileList.is_bank_details,
        "is_bank_asdasdetails",
      );

      // bankval = state.EmployeeProfile.EmployeeProfileList.is_bank_details;
      console.log(bankval, "0weo0wlvbankval");

      dispatch(
        CreateResponse_store(
          state.EmployeeProfile.EmployeeProfileList.is_bank_details,
        ),
      );
    }
    //  else{
    //   setWhatsApp(false);
    //   // setWhatsApp(true);
    //   // dispatch(CreateResponse_store(false))

    //  }
  }, [state.EmployeeProfile.EmployeeProfileList]);
  // console.log(state.pennydropforBank ,"state.pennydropforBank.BankVerify", state.FormsIDList.BankDetailID);

  useEffect(() => {
    // IsBankVerified = state.pennydropforBank.BankVerify;
    setIsBankVerified(state?.pennydropforBank?.BankVerify);
  }, [state.pennydropforBank.BankVerify]);
  ///---file---upload---
  const handleDropFront = (e) => {
    isUploadingRef.current = true;
    setImageField((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.files[0],
      };
    });
    // console.log(e.target.files[0], "sjcbas bsk");

    var reader = new FileReader();
    reader.onloadend = function () {
      // setImage(reader.result);
      setImageFieldurl({ ...ImageFieldUrl, frontImage: reader.result });
      // console.log(reader.result, "results");
      setBankUplo(true);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  useEffect(() => {
    isUploadingRef.current = false;
  }, [propsID]);

  useEffect(() => {
    if (state.CasualApproveRequestDatas.Inquriy && !isUploadingRef.current) {
      const responseData = state.CasualApproveRequestDatas.Inquriy;

      setAccountName(responseData?.account_holder_name);
      setDatas({
        account_holder_name: responseData?.account_holder_name,
        account_number: responseData?.account_number,
        bank_branch: responseData?.bank_branch,
        bank_name: responseData?.bank_name,
        ifsc_code: responseData?.ifsc_code,
      });
      setUrl(responseData?.bank_image);
      seturlandfile({
        url: responseData?.bank_image || "",
      });
      setPhoneNumber({
        ...PhoneNumber,
        phone_number: responseData?.phone_number,
      });
      setIsBankVerified(responseData?.is_bank_verified);
    }
  }, [state.CasualApproveRequestDatas.Inquriy]);

  console.log(data, "datadatadatadatadata");

  const NameFuncation = () => {
    if (
      (state.FormsIDList.BankDetailID == "" &&
        state.NumberCounts.FirstName.toUpperCase() !==
        state.pennydropforBank.Bank_Holder_Name) ||
      (state.FormsIDList.BankDetailID != "" &&
        state.pennydropforBank.Bank_Holder_Name.toUpperCase() !=
        state.BankDetails.Bankdata.account_holder_name.toUpperCase()) ||
      state.NumberCounts.BankNameVerification
    ) {
      Swal.fire({
        html: `
      <div style="text-align:left;  line-height: 1.5;">
        <p><strong>Name as per ${state.FormsIDList.BankDetailID === "" ? "Aadhaar" : "Previous Data"
          }:</strong> ${state.FormsIDList.BankDetailID === ""
            ? state.NumberCounts.FirstName
            : state.BankDetails.Bankdata.account_holder_name
          }</p>
        <p><strong>Name as per Bank:</strong> ${state.pennydropforBank.Bank_Holder_Name}</p>
        <hr style="border: 0.5px solid #ccc; margin: 10px 0;">
        <p style="margin-top: 10px;">The name you entered differs from your Aadhaar card name. Do you want to proceed?</p>
<label for="swal-input" style="display:block; text-align:left; margin-top:10px; font-weight:bold;">Remarks:</label>
<select id="swal-input" class="swal2-select" style="width:100%; margin-top:6px;">
  <option value="">-- Select Remarks --</option>
  <option value="Name Mismatch - Verified">Name Mismatch – Verified</option>
  <option value="IFSC Changed - Verified">IFSC Changed – Verified</option>
  <option value="Other Changes - Verified">Other Changes – Verified</option>
</select>
      </div>
    `,

        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#234492",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes",
        allowOutsideClick: false,

        // preConfirm: (acknowledgement) => {
        //   if (!acknowledgement.trim()) {
        //     Swal.showValidationMessage('Acknowledgement is required!');
        //     return false;
        //   }
        //   return acknowledgement.trim(); // Return the trimmed acknowledgement
        // },
        preConfirm: () => {
          const acknowledgement = document
            .getElementById("swal-input")
            .value.trim();
          if (!acknowledgement) {
            Swal.showValidationMessage("Remarks is required!");
            return false;
          }
          return acknowledgement; // Return the trimmed acknowledgment
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const fetchUploadFiles = async () => {
            await Promise.all(
              PresentUrls.map(async (item) => {
                try {
                  const response = await fetch(item.url, {
                    method: "PUT",
                    headers: {
                      "Content-Type": item.type,
                      "x-amz-acl": "public-read",
                    },
                    body: item.putfiles,
                  });

                  if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                  }

                  const data = await response.json();
                  console.log("Files uploaded successfully:", data);
                  setUrl(presenturlInUrl.url);
                  setPresentUrls([]);
                } catch (error) {
                  console.error("Error uploading files:", error);
                }
              }),
            );
          };

          if (result.isConfirmed) {
            console.log("User Details:", result.value);
            if (state.FormsIDList.BankDetailID == "") {
              let CreateBankDetails = {
                account_number: data.account_number
                  ? data.account_number.trim()
                  : "",
                bank_branch: data.bank_branch ? data.bank_branch.trim() : "",
                ifsc_code: data.ifsc_code ? data.ifsc_code.trim() : "",
                // timeline_id: state.BasicFormCreated.BasciFormCreate,
                timeline_id:
                  state.BasicFormCreated.BasciFormCreate == ""
                    ? state.EmployeeProfile.EmployeeProfileList.id
                    : state.BasicFormCreated.BasciFormCreate,
                bank_name: data.bank_name ? data.bank_name.trim() : "",
                account_holder_name: state.pennydropforBank.Bank_Holder_Name
                  ? state.pennydropforBank.Bank_Holder_Name.trim()
                  : "",

                bank_transaction_id: state.pennydropforBank.transaction_id,
                // is_bank_details:state.pennydropforBank.BankVerify ,
                is_bank_details: Array.isArray(
                  state.pennydropforBank.BankVerify,
                )
                  ? false
                  : state.pennydropforBank.BankVerify,
                account_exists: state.pennydropforBank.AccountExit,
                // bank_count: state.OnboardngCounts.bank_count,
                bank_count: Number(state.OnboardngCounts.bank_count),
                bank: presenturlInUrl.url,
                remarks: result.value,
              };

              if (BankImageCAnUplo) {
                formdata.append("bank", file[0]);
              }

              if (BankImageCAnUplo == true) {
                fetchUploadFiles();
              }

              const payload = {
                formdata: CreateBankDetails,
                Retieveid: state.FormsIDList.BankDetailID,
              };

              dispatch(setBankDataCreateActions(payload));
            } else if (
              (state.FormsIDList.BankDetailID ==
                state.BankDetails.Bankdata.id &&
                state.FormsIDList.BankDetailID != "" &&
                state.pennydropforBank.Bank_Holder_Name !=
                state.BankDetails.Bankdata.account_holder_name) ||
              data.account_number !=
              state.BankDetails.Bankdata.account_number ||
              data.bank_name != state.BankDetails.Bankdata.bank_name ||
              data.ifsc_code != state.BankDetails.Bankdata.ifsc_code ||
              data.bank_branch != state.BankDetails.Bankdata.bank_branch ||
              url != state.BankDetails.Bankdata.bank_id?.media_url?.media_url
            ) {
              let EditBankDetails = {
                account_number: data.account_number
                  ? data.account_number.trim()
                  : "",
                bank_branch: data.bank_branch ? data.bank_branch.trim() : "",
                ifsc_code: data.ifsc_code ? data.ifsc_code.trim() : "",
                timeline_id:
                  state.BasicFormCreated.BasciFormCreate == ""
                    ? state.EmployeeProfile.EmployeeProfileList.id
                    : state.BasicFormCreated.BasciFormCreate,
                bank_name: data.bank_name ? data.bank_name.trim() : "",
                account_holder_name: state.pennydropforBank.Bank_Holder_Name
                  ? state.pennydropforBank.Bank_Holder_Name.trim()
                  : "",
                bank_transaction_id: state.pennydropforBank.transaction_id,
                // is_bank_details:state.pennydropforBank.BankVerify ,
                is_bank_details: Array.isArray(
                  state.pennydropforBank.BankVerify,
                )
                  ? false
                  : state.pennydropforBank.BankVerify,
                account_exists: state.pennydropforBank.AccountExit,
                bank_count: Number(state.OnboardngCounts.bank_count),
                bank: presenturlInUrl.url,
                remarks: result.value,
              };

              if (BankImageCAnUplo) {
                editform.append("bank", file[0]);
              }

              if (BankImageCAnUplo == true) {
                fetchUploadFiles();
              }
              const payload = {
                formdata: EditBankDetails,
                Retieveid: state.FormsIDList.BankDetailID,
              };
              dispatch(setBankDataEditActions(payload));
              setBankUplo(false);
            }

            // setNameState(false);
            else if (
              state.FormsIDList.BankDetailID != "" &&
              state.pennydropforBank.Bank_Holder_Name ==
              state.BankDetails.Bankdata.account_holder_name &&
              data.account_number ==
              state.BankDetails.Bankdata.account_number &&
              data.bank_name == state.BankDetails.Bankdata.bank_name &&
              data.ifsc_code == state.BankDetails.Bankdata.ifsc_code &&
              data.bank_branch == state.BankDetails.Bankdata.bank_branch &&
              whatsApp == state.pennydropforBank.BankVerify &&
              url == state.BankDetails.Bankdata.bank_id?.media_url
            ) {
              dispatch(SetActiveTabs(5));
            }
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire({
            text: "Employee Bank Details Form has been canceled",
            icon: "error",
          });
          setNameState(true);
          Swal.close();
        }
      });
    }
  };
  useEffect(() => {
    setAccountName(state.pennydropforBank.Bank_Holder_Name);
  }, [state.pennydropforBank.Bank_Holder_Name]);

  const inputRef = useRef(null);
  // const preventZoom = (event) => {
  //    console.log(event ,"asdasdevent",event?.type  =="wheel" ,"sadasdasd");

  //   if (event.ctrlKey || event.metaKey) {
  //     event.preventDefault();
  //   }

  //   if (event?.type  =="wheel") {
  //     event.preventDefault();
  //   }

  //    if (["e", "E", "+", "-", "."].includes(event.key)) {
  //     event.preventDefault();
  // }
  // if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
  //   event.preventDefault();
  // }

  // // if (evt.ctrlKey || evt.metaKey) {
  // //   evt.preventDefault();
  // // }
  // };

  // const preventZoom = (event) => {
  //   // if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.type === "wheel")) {
  //   //   event.preventDefault();
  //   // }
  //   //   if (["e", "E", "+", "-", "."].includes(event.key) || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
  //   //   event.preventDefault();
  //   // }
  //   if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.type === 'wheel') || event._reactName == "onWheel"
  //   && event._reactName != "onKeyDown"
  //     ) {
  //       event.preventDefault();
  //     }

  //     // Prevent unwanted keys: 'e', '+', '-', '.', Arrow keys, and prevent zooming with the mouse wheel
  //     if (["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"].includes(event.key) || event.type === "wheel"
  //     || event._reactName == "onWheel"
  //   &&   event._reactName != "onKeyDown") {
  //       event.preventDefault();
  //     }
  // };
  // const handlePaste = (event) => {
  //   let paste = (event.clipboardData || window.clipboardData).getData('text');
  //     const filtered = paste.replace(/[^0-9]/g, '');
  //     event.preventDefault();

  //   if(event.target.name != "phone_number"){
  //     event.target.value = filtered;
  //     HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic

  //   }
  //    else {
  //     setPhoneNumber({
  //       ...PhoneNumber,
  //       phone_number: filtered,
  //     });

  //    }
  // };

  const preventZoom = (event) => {
    console.log(event._reactName, "Sdasd event", event, event.nativeEvent);

    // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
    if (
      ((event.ctrlKey || event.metaKey) &&
        (event.key === "+" || event.key === "-" || event.type === "wheel")) ||
      event._reactName == "onWheel" ||
      event._reactName != "onKeyDown"
    ) {
      event.preventDefault();
    }

    // Prevent unwanted keys: 'e', '+', '-', '.', Arrow keys, and prevent zooming with the mouse wheel
    if (
      ["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"].includes(event.key) ||
      event.type === "wheel" ||
      event._reactName == "onWheel" ||
      event._reactName != "onKeyDown"
    ) {
      event.preventDefault();
    }
    if (event._reactName == "onWheel" && event._reactName != "onKeyDown") {
      console.log("prevent eri ");

      event.preventDefault();
    }
  };

  const handlePaste = (event) => {
    const paste = (event.clipboardData || window.clipboardData).getData("text");
    const filtered = paste.replace(/[^0-9]/g, ""); // Strip non-numeric characters
    event.preventDefault();
    event.target.value = filtered;
    if (event.target.name != "phone_number") {
      event.target.value = filtered;
      HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
    } else {
      setPhoneNumber({
        ...PhoneNumber,
        phone_number: filtered,
      });
    }
  };

  const preventwheel = (event) => {
    if (
      (event.target && event.target.className == "form-control") ||
      event.target.class == "form-control"
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (
        (event.target && event.target.className == "form-control") ||
        event.target.class == "form-control"
      ) {
        event.preventDefault();
      }
    };
    if (inputElement) {
      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);

  console.log(state.pennydropforBank.BankVerify, "BankVerify BankVerify");

  //----Next-------
  const HandleNext = () => {
    if (
      state.EmployeeProfile.EmployeeProfileList != undefined &&
      state.EmployeeProfile.EmployeeProfileList != null &&
      state.EmployeeProfile.EmployeeProfileList.education_details != null &&
      state.EmployeeProfile.EmployeeProfileList.education_details !=
      undefined &&
      state.EmployeeProfile.EmployeeProfileList.id != undefined &&
      state.EmployeeProfile.EmployeeProfileList.education_details.id !=
      undefined
    ) {
      dispatch(
        SetEducationDetails(
          state.EmployeeProfile.EmployeeProfileList.education_details.id,
        ),
      );
    }

    const fetchUploadFiles = async () => {
      await Promise.all(
        PresentUrls.map(async (item) => {
          try {
            const response = await fetch(item.url, {
              method: "PUT",
              headers: {
                "Content-Type": item.type,
                "x-amz-acl": "public-read",
              },
              body: item.putfiles,
            });

            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            console.log("Files uploaded successfully:", data);
            setUrl(presenturlInUrl.url);
            setPresentUrls([]);
          } catch (error) {
            console.error("Error uploading files:", error);
          }
        }),
      );
    };
    var a = 0;

    if (
      state.NumberCounts.BankNameVerification === true &&
      state.pennydropforBank.Bank_Holder_Name.trim() != "" &&
      data.account_number !== "" &&
      data.bank_branch !== "" &&
      data.ifsc_code !== "" &&
      url !== undefined &&
      url !== null &&
      url !== ""
    ) {
      console.log("test", state.NumberCounts.BankNameVerification);

      NameFuncation();
    }

    if (state.pennydropforBank.Bank_Holder_Name.trim() == "") {
      setAcNameErr("*Account Holder Name is required");
      a = 1;
    }
    if (url == undefined || url == null || url == "") {
      setBankimgErr("*cheque leaf or Passbook  Image is required");
      console.log("ewoiwu");

      a = 1;
    }

    if (data.account_number == "") {
      setAccNumErr("*Account Number is required");
      a = 1;
    }

    if (data.bank_branch == "") {
      setBankBranchErr("*Bank Branch Name is required");
      a = 1;
    }
    if (data.ifsc_code == "") {
      setIfsErr("*IFSC code  is required");
      a = 1;
    }
    if (data.bank_name == "") {
      setBankErr("*Bank Name is required");
      a = 1;
    }
    if (PhoneNumber.phone_number == "") {
      a = 1;
      setPhoneErr("Verifing the Bank Phone Number is required");
    }
    if (
      state.NumberCounts.BankNameVerification == false &&
      state.FormsIDList.BankDetailID == ""
    ) {
      let CreateBankDetails = {
        account_number: data.account_number ? data.account_number.trim() : "",
        bank_branch: data.bank_branch ? data.bank_branch.trim() : "",
        ifsc_code: data.ifsc_code ? data.ifsc_code.trim() : "",
        // timeline_id: state.BasicFormCreated.BasciFormCreate,
        timeline_id:
          state.BasicFormCreated.BasciFormCreate == ""
            ? state.EmployeeProfile.EmployeeProfileList.id
            : state.BasicFormCreated.BasciFormCreate,
        bank_name: data.bank_name ? data.bank_name.trim() : "",
        account_holder_name: state.pennydropforBank.Bank_Holder_Name
          ? state.pennydropforBank.Bank_Holder_Name.trim()
          : "",

        bank_transaction_id: state.pennydropforBank.transaction_id,
        // is_bank_details:state.pennydropforBank.BankVerify ,
        is_bank_details: Array.isArray(state.pennydropforBank.BankVerify)
          ? false
          : state.pennydropforBank.BankVerify,
        account_exists: state.pennydropforBank.AccountExit,
        // bank_count: state.OnboardngCounts.bank_count,
        bank_count: Number(state.OnboardngCounts.bank_count),
        bank: presenturlInUrl.url,
        remarks: "",
      };
      if (state.pennydropforBank.Bank_Holder_Name.trim() == "") {
        setAcNameErr("*Account Holder Name is required");
        a = 1;
      }

      if (data.account_number == "") {
        setAccNumErr("*Account Number is required");
        a = 1;
      }

      if (data.bank_branch == "") {
        setBankBranchErr("*Bank Branch Name is required");
        a = 1;
      }
      if (data.ifsc_code == "") {
        setIfsErr("*IFSC code  is required");
        a = 1;
      }
      if (data.bank_name == "") {
        setBankErr("*Bank Name is required");
        a = 1;
      }
      if (PhoneNumber.phone_number == "") {
        a = 1;
        setPhoneErr("Verifing the Bank Phone Number is required");
      }
      if (BankImageCAnUplo) {
        form2.append("bank", file[0]);
      }

      if (url == undefined || url == null || url == "") {
        setBankimgErr("*cheque leaf or Passbook  Image is required");
        console.log("ewoiwu");

        a = 1;
      }

      if (a == 0 && validateed == 0 && BankImageCAnUplo == true) {
        fetchUploadFiles();
      }

      // }
      if (
        !state.NumberCounts.BankNameVerification &&
        a == 0 &&
        validateed == 0
      ) {
        const payload = {
          formdata: CreateBankDetails,
          Retieveid: state.FormsIDList.BankDetailID,
          //     timeline_id: state.EmployeeProfile.EmployeeProfileList.id,
        };
        // console.log(data, "wertyioplkjhh");
        // if(IsBankVerified){

        dispatch(setBankDataCreateActions(payload));
        // }
      }
    } else if (
      //  state.FormsIDList.BankDetailID != '' &&
      //  state.FormsIDList.BankDetailID == state.BankDetails.Bankdata.id &&

      //  state.NumberCounts.BankNameVerification == false  &&
      // state.FormsIDList.BankDetailID != "" &&
      // state.pennydropforBank.Bank_Holder_Name !=
      //     state.BankDetails.Bankdata.account_holder_name ||
      // data.account_number != state.BankDetails.Bankdata.account_number ||
      // data.bank_name != state.BankDetails.Bankdata.bank_name ||
      // data.ifsc_code != state.BankDetails.Bankdata.ifsc_code ||
      // data.bank_branch != state.BankDetails.Bankdata.bank_branch ||
      // whatsApp != state.pennydropforBank.BankVerify ||
      //  url != state.BankDetails.Bankdata.bank_id?.media_url

      state.FormsIDList.BankDetailID == state.BankDetails.Bankdata.id &&
      state.FormsIDList.BankDetailID != "" &&
      state.NumberCounts.BankNameVerification == false &&
      ((state.NumberCounts.BankNameVerification == false &&
        state.FormsIDList.BankDetailID != "" &&
        state.pennydropforBank.Bank_Holder_Name !=
        state.BankDetails.Bankdata.account_holder_name) ||
        data.account_number != state.BankDetails.Bankdata.account_number ||
        data.bank_name != state.BankDetails.Bankdata.bank_name ||
        data.ifsc_code != state.BankDetails.Bankdata.ifsc_code ||
        data.bank_branch != state.BankDetails.Bankdata.bank_branch ||
        whatsApp != state.pennydropforBank.BankVerify ||
        url != state.BankDetails.Bankdata.bank_id?.media_url)
    ) {
      // if(state.NumberCounts.Editable != 1){
      if (state.pennydropforBank.Bank_Holder_Name.trim() == "") {
        setAcNameErr("*Account Holder Name is required");
        a = 1;
      }

      if (data.account_number == "") {
        setAccNumErr("*Account Number is required");
        a = 1;
      }

      if (url == undefined || url == null || url == "") {
        setBankimgErr("*cheque leaf or Passbook  Image is required");
        a = 1;
      }
      // if (data.account_number.length > 14) {
      //   setAccNumErr("*Account Number should not exit more than 14  numbers");
      //   a = 1;
      // }

      // if (data.account_number.length < 12) {
      //   setAccNumErr("*Account Number should not exit less than  12 numbers");
      //   a = 1;
      // }

      if (data.bank_branch == "") {
        setBankBranchErr("*Bank Branch Name is required");
        a = 1;
      }
      if (data.ifsc_code == "") {
        setIfsErr("*IFSC code  is required");
        a = 1;
      }

      if (data.bank_name == "") {
        setBankErr("*Bank Name is required");
        a = 1;
      }

      if (BankImageCAnUplo) {
        editform2.append("bank", file[0]);
      }

      let EditBankDetails = {
        account_number: data.account_number ? data.account_number.trim() : "",
        bank_branch: data.bank_branch ? data.bank_branch.trim() : "",
        ifsc_code: data.ifsc_code ? data.ifsc_code.trim() : "",
        timeline_id:
          state.BasicFormCreated.BasciFormCreate == ""
            ? state.EmployeeProfile.EmployeeProfileList.id
            : state.BasicFormCreated.BasciFormCreate,
        bank_name: data.bank_name ? data.bank_name.trim() : "",
        account_holder_name: state.pennydropforBank.Bank_Holder_Name
          ? state.pennydropforBank.Bank_Holder_Name.trim()
          : "",
        bank_transaction_id: state.pennydropforBank.transaction_id,
        account_exists: state.pennydropforBank.AccountExit,
        // bank_count: state.OnboardngCounts.bank_count,
        bank_count: Number(state.OnboardngCounts.bank_count),
        bank: presenturlInUrl.url,
        // is_bank_details:state.pennydropforBank.BankVerify ,
        is_bank_details: Array.isArray(state.pennydropforBank.BankVerify)
          ? false
          : state.pennydropforBank.BankVerify,
        // is_bank_details:true ,

        remarks: "",
      };
      if (a == 0 && validateed == 0 && BankImageCAnUplo == true) {
        fetchUploadFiles();
      }

      // }
      for (let [key, value] of editform2.entries()) {
        console.log(`${key}: ${value}`, "iutesting the formdatas"); // Log each key-value pair
      }

      if (
        // !NameState &&
        a == 0 &&
        validateed == 0
      ) {
        const payload = {
          formdata: EditBankDetails,
          Retieveid: state.FormsIDList.BankDetailID,
        };

        dispatch(setBankDataEditActions(payload));
        setBankUplo(false);
      }
    } else if (
      state.FormsIDList.BankDetailID == state.BankDetails.Bankdata.id &&
      state.FormsIDList.BankDetailID != "" &&
      state.NumberCounts.BankNameVerification == false &&
      state.FormsIDList.BankDetailID != "" &&
      state.pennydropforBank.Bank_Holder_Name ==
      state.BankDetails.Bankdata.account_holder_name &&
      data.account_number == state.BankDetails.Bankdata.account_number &&
      data.bank_name == state.BankDetails.Bankdata.bank_name &&
      data.ifsc_code == state.BankDetails.Bankdata.ifsc_code &&
      data.bank_branch == state.BankDetails.Bankdata.bank_branch &&
      // !BankImageCAnUplo
      whatsApp == state.pennydropforBank.BankVerify &&
      url == state.BankDetails.Bankdata.bank_id?.media_url
    ) {
      // if(state.pennydropforBank.BankVerify){
      dispatch(SetActiveTabs(5));
      // }
    }
  };

  const updateAvatar = (imgSrc) => {
    fileInputRef.current = imgSrc;
  };

  console.log(
    (state.ClientBranchIDs.SUBROLE == 3 ||
      state.ClientBranchIDs.SUBROLE == 0 ||
      state.ClientBranchIDs.SUBROLE == 1) &&
    state.NumberCounts.Editable == 1 &&
    state.NumberCounts.EmployeeFormFIll == true,
    PennyDropVerification,

    "dsoopidpoad",
    state.ClientBranchIDs.SUBROLE,
    state.NumberCounts.EmployeeFormFIll,
  );

  // console.log(state.pennydropforBank.BankVerify ,"pennydropforBank.BankVerify" );

  const fetchUploadFiles = async () => {
    await Promise.all(
      PresentUrls.map(async (item) => {
        try {
          if (item != undefined && item != null) {
            const response = await fetch(item.url, {
              method: "PUT",
              headers: {
                "Content-Type": item.type,
                "x-amz-acl": "public-read",
              },
              body: item.putfiles,
            });

            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }

            setUrl(presenturlInUrl.url);
          }
        } catch (error) {
          console.error("Error uploading files:", error);
        }
      }),
    );
  };

  const HandleSaveNext = async () => {
    let hasError = false;

    if (!data?.account_holder_name || data.account_holder_name.trim() === "") {
      setAcNameErr("Account Holder Name is required");
      hasError = true;
    } else {
      setAcNameErr("");
    }

    if (!data?.bank_name || data.bank_name.trim() === "") {
      setBankErr("Bank Name is required");
      hasError = true;
    } else {
      setBankErr("");
    }

    if (!data?.bank_branch || data.bank_branch.trim() === "") {
      setBankBranchErr("Bank Branch is required");
      hasError = true;
    } else {
      setBankBranchErr("");
    }

    if (!data?.ifsc_code || data.ifsc_code.trim() === "") {
      setIfsErr("IFSC Code is required");
      hasError = true;
    } else {
      setIfsErr("");
    }

    if (!data?.account_number || data.account_number.trim() === "") {
      setAccNumErr("Account Number is required");
      hasError = true;
    } else {
      setAccNumErr("");
    }

    if (!PhoneNumber?.phone_number || PhoneNumber.phone_number.trim() === "") {
      setPhoneErr("Phone Number is required");
      hasError = true;
    } else {
      setPhoneErr("");
    }

    if (hasError) {
      toast.error("Please fill all mandatory fields.");
      return;
    }

    if (PresentUrls && PresentUrls.length > 0) {
      await fetchUploadFiles();
    }

    const empFirstName = state.CasualApproveRequestDatas?.Inquriy?.first_name || "";
    const empLastName = state.CasualApproveRequestDatas?.Inquriy?.last_name || "";
    const employeeFullName = `${empFirstName} ${empLastName}`.replace(/\s+/g, ' ').trim().toUpperCase();
    const accountHolderName = (data?.account_holder_name || "").replace(/\s+/g, ' ').trim().toUpperCase();

    if (employeeFullName !== accountHolderName) {
      Swal.fire({
        title: "Account Holder Name Mismatch",
        text: "The account holder name does not match the employee name. Please provide remarks to proceed.",
        input: "textarea",
        inputPlaceholder: "Enter remarks here...",
        inputAttributes: {
          "aria-label": "Enter remarks here",
        },
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Save & Continue",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#234492",
        cancelButtonColor: "#6c757d",
        preConfirm: (remarks) => {
          if (!remarks || remarks.trim() === "") {
            Swal.showValidationMessage("Remarks are required!");
            return false;
          }
          return remarks;
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const remarks = result.value;
          const payload = {
            id: propsID,
            data: {
              account_number: data.account_number ? data.account_number.trim() : "",
              bank_branch: data.bank_branch ? data.bank_branch.trim() : "",
              ifsc_code: data.ifsc_code ? data.ifsc_code.trim() : "",
              bank_image: presenturlInUrl.url || url,
              account_holder_name: data.account_holder_name,
              bank_name: data.bank_name,
              is_bank_verified: isBankVerified,
              remarks: remarks,
            },
            Functions: () => {
              dispatch(SetCasualActiveTabs(5));
            },
          };
          dispatch(setCasualFormUpdateActions(payload));
          setPresentUrls([]);
        }
      });
    } else {
      const payload = {
        id: propsID,
        data: {
          account_number: data.account_number ? data.account_number.trim() : "",
          bank_branch: data.bank_branch ? data.bank_branch.trim() : "",
          ifsc_code: data.ifsc_code ? data.ifsc_code.trim() : "",
          bank_image: presenturlInUrl.url || url,
          account_holder_name: data.account_holder_name,
          bank_name: data.bank_name,
          is_bank_verified: isBankVerified,
          remarks: "",
        },
        Functions: () => {
          dispatch(SetCasualActiveTabs(5));
        },
      };
      dispatch(setCasualFormUpdateActions(payload));
      setPresentUrls([]);
    }
  };

  console.log(state.pennydropforBank.BankVerify, "sjkdjasjkdasdasjdjkas");

  return (
    <>
      <div className=" BodyContent">
        <div className="card">
          <div className="card-body cards ">
            <div className="UserPoup">
              <div className="BeforForms">
                <div className="Form">
                  <div className="ModalHeader">
                    <div>
                      <span>Bank Details</span>
                    </div>
                  </div>
                  <div className="Modal-Body ModalForms">
                    {state.NumberCounts.Editable == 2 ||
                      state.ClientBranchIDs.SUBROLE == 3 ? (
                      <div className="col-6 mt-3">
                        <div>
                          <small style={{ color: "red" }}>
                            Note:Upload the cheque leaf or Passbook picture,
                            please. Verify that the file is in the JPG, JPEG, or
                            PNG format and that its size is less than 10 MB.
                          </small>
                        </div>

                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            flexDirection: "row",
                          }}
                        >
                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "flex-start",
                              flexDirection: "row",
                            }}
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              onChange={(e) =>
                                handlePassBookChnages(e, "cheque ", true, false)
                              }
                              checked={PasChec.cheque}
                              style={{ cursor: "pointer" }}
                            />
                            cheque leaf
                          </label>

                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ width: "100%" }}
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              onChange={(e) =>
                                handlePassBookChnages(
                                  e,
                                  "passbook",
                                  false,
                                  true,
                                )
                              }
                              checked={PasChec.passbook}
                              style={{ cursor: "pointer" }}
                            />
                            Passbook
                          </label>
                        </div>

                        <div className="row">
                          <div className="col" style={{ marginTop: "20px" }}>
                            {url ? (
                              <img
                                src={url}
                                className="pointer"
                                onClick={(e) => {
                                  if (state.NumberCounts.Editable == 1) {
                                    window.open(url);
                                  }
                                }}
                                style={{
                                  // height: 115,
                                  // width: 115,
                                  // marginRight: 25,
                                  // borderRadius: "50%",
                                  height: "153px",
                                  width: "198px",
                                  margin: "13px 25px 21px 0px",
                                  border: "4px solid #234492",
                                  marginRight: "25",
                                  borderRadius: "12px",
                                }}
                                alt="Image"
                              />
                            ) : null}

                            {!url ? (
                              <Button
                                className="btn doctorupload"
                                variant="contained"
                                component="label"
                                style={{
                                  background: "#234492",
                                  color: "#fff",
                                  fontSize: "11px !important",
                                }}
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                              >
                                <input
                                  type="file"
                                  hidden
                                  accept="image/png, image/jpeg"
                                  onChange={(e) => {
                                    handleFiles(e);
                                    setBankimgErr("");
                                  }}
                                  ref={fileInputRef}
                                />
                                Upload Image
                              </Button>
                            ) : (
                              <></>
                            )}

                            {url ? (
                              <div
                                className="w-100 d-flex "
                                style={{ gap: "12px", flexDirection: "column" }}
                              >
                                <Button
                                  className="btn remove doctorupload"
                                  variant="contained"
                                  onClick={(e) => cancel(e)}
                                  style={{
                                    background: "#234492",
                                    color: "#fff",
                                    fontSize: "11px !important",
                                    width: "fit-content",
                                  }}
                                >
                                  Remove Image
                                </Button>
                                <Downloads_doc url={url} />
                              </div>
                            ) : (
                              ""
                            )}
                            <p
                              className="Error"
                              style={{ marginLeft: "-5px", marginTop: "10px" }}
                            >
                              {banckImgeErr}
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <div className="row">
                      <div className="col-12 BankVerified">
                        <div className="col-6"></div>
                        <div className="col-6 BankCorrection">
                          {/* <i class="fa-solid fa-circle-check"
                      
                      style={
                        style

                       }
                       ></i> */}

                          <span className="BankVerifiedImages">
                            {isBankVerified ? (
                              <img src={BankAsVerifyed} />
                            ) : (
                              <img src={banknotVerifed} />
                            )}
                          </span>
                          {/* <span className="BankverifiedImage">  <img src={BankImage}/></span> */}
                        </div>
                      </div>
                      <div className="col-sm-3 mt-3">
                        <label for="validationCustom01" class="form-label">
                          Account Holder name
                          <span style={{ color: "red" }}>*</span>

                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom01"
                          autocomplete="off"
                          name="account_holder_name"
                          value={data?.account_holder_name}
                          onChange={(e) => {
                            setAcNameErr("");
                            dispatch(
                              settheBankHolderName(
                                e.target.value.toUpperCase(),
                              ),
                            );

                            HandleChanges(e);
                          }}
                        />

                        <p className="Error" style={{ marginLeft: "-5px" }}>
                          {accountNameErr}
                        </p>
                      </div>
                      <div className="col-sm-3 mt-3">
                        <label for="validationCustom01" class="form-label">
                          Bank Name
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom01"
                          autocomplete="off"
                          name="bank_name"
                          value={data.bank_name}
                          readOnly={
                            state.NumberCounts.Editable == 1 &&
                              EmailID != "admin@gmail.com" &&
                              EmailID != "admin@qpms.in"
                              ? true
                              : false
                          }
                          disabled={
                            state.NumberCounts.Editable == 1 &&
                              EmailID != "admin@gmail.com" &&
                              EmailID != "admin@qpms.in"
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            HandleChanges(e);
                            // setBankErr("");

                            if (e.target.value.length > 255) {
                              setValidated(1);
                              setBankErr(
                                "*Bank Name cannot exceed 255 characters.",
                              );
                            } else {
                              setValidated(0);
                              setBankErr(""); // Clear the error if the input is valid
                            }
                          }}
                        />
                        <p className="Error" style={{ marginLeft: "-5px" }}>
                          {BankNaErr}
                        </p>
                      </div>

                      <div className="col-sm-3  mt-3">
                        <label for="validationCustom01" class="form-label">
                          Bank Branch
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom01"
                          autocomplete="off"
                          name="bank_branch"
                          value={data.bank_branch}
                          readOnly={
                            (state.ClientBranchIDs.SUBROLE == 3 ||
                              state.ClientBranchIDs.SUBROLE == 0 ||
                              state.ClientBranchIDs.SUBROLE == 1) &&
                              state.NumberCounts.Editable == 1 &&
                              state.NumberCounts.EmployeeFormFIll == true
                              ? // &&
                              // PennyDropVerification == false
                              false
                              : PennyDropVerification == true &&
                                EmailID != "admin@gmail.com" &&
                                EmailID != "admin@qpms.in"
                                ? true
                                : false
                          }
                          disabled={
                            (state.ClientBranchIDs.SUBROLE == 3 ||
                              state.ClientBranchIDs.SUBROLE == 0 ||
                              state.ClientBranchIDs.SUBROLE == 1) &&
                              state.NumberCounts.Editable == 1 &&
                              state.NumberCounts.EmployeeFormFIll == true
                              ? // &&
                              // PennyDropVerification == false
                              false
                              : PennyDropVerification == true &&
                                EmailID != "admin@gmail.com" &&
                                EmailID != "admin@qpms.in"
                                ? true
                                : false
                          }
                          onChange={(e) => {
                            setBankBranchErr("");
                            HandleChanges(e);
                          }}
                        />
                        <p className="Error" style={{ marginLeft: "-5px" }}>
                          {bankBranchErr}
                        </p>
                      </div>
                      <div className="col-sm-3 mt-3">
                        <label for="validationCustom01" class="form-label">
                          IFSC code
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        {/* <input
                          type="text"
                          class="form-control"
                          id="validationCustom01"
                          autocomplete="off"
                          name="ifsc_code"
                          value={
                            data.ifsc_code
                              ? data.ifsc_code.slice(0, 11)
                              : ""
                          }
                          disabled={
                            state.NumberCounts.Editable == 1 &&
                            state.ClientBranchIDs.SUBROLE != 3
                              ? true
                              : false
                          }
                          readOnly={
                            state.NumberCounts.Editable == 1 &&
                            state.ClientBranchIDs.SUBROLE != 3
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            HandleChanges(e);
                            setIfsErr("");
                          }}
                        /> */}
                        <input
                          type="text"
                          className="form-control"
                          id="validationCustom01"
                          autoComplete="off"
                          name="ifsc_code"
                          value={
                            data.ifsc_code ? data.ifsc_code.slice(0, 30) : ""
                          }
                          disabled={
                            (state.ClientBranchIDs.SUBROLE == 3 ||
                              state.ClientBranchIDs.SUBROLE == 0 ||
                              state.ClientBranchIDs.SUBROLE == 1) &&
                              state.NumberCounts.Editable == 1 &&
                              state.NumberCounts.EmployeeFormFIll == true
                              ? // &&
                              // PennyDropVerification == false
                              false
                              : PennyDropVerification == true &&
                                EmailID != "admin@gmail.com" &&
                                EmailID != "admin@qpms.in"
                                ? true
                                : false
                          }
                          readOnly={
                            (state.ClientBranchIDs.SUBROLE == 3 ||
                              state.ClientBranchIDs.SUBROLE == 0 ||
                              state.ClientBranchIDs.SUBROLE == 1) &&
                              state.NumberCounts.Editable == 1 &&
                              state.NumberCounts.EmployeeFormFIll == true
                              ? // &&
                              // PennyDropVerification == false

                              false
                              : PennyDropVerification == true &&
                                EmailID != "admin@gmail.com" &&
                                EmailID != "admin@qpms.in"
                                ? true
                                : false
                          }
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length > 30) {
                              e.preventDefault();
                              setIfsErr(
                                "*IFSC code must not exceed 30 characters.",
                              );
                              setValidated(1);
                            } else {
                              setIfsErr("");
                              setValidated(0);
                              HandleChanges(e);
                            }
                          }}
                        />

                        <p className="Error" style={{ marginLeft: "-5px" }}>
                          {IFSErr}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3 mt-3">
                        <label for="validationCustom01" class="form-label">
                          Account Number
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        {/* <input
                          type="number"
                          // onKeyDown={(evt) =>
                          //   ["e", "E", "+", "-"].includes(evt.key) &&
                          //   evt.preventDefault()
                          // }
                          step="1"
                              onKeyDown={(evt) => {
                                if (["e", "E", "+", "-", "."].includes(evt.key)) {
                                  evt.preventDefault();
                                }
                              }}
                          class="form-control"
                          id="                              onChange={(e) => {
                                const value = parseInt(e.target.value, 10);
                                HandleChanges(e);
                                if (value > 0) {
                              
                                  sphoneerro("");
                                  setValidations(0);

                                } else {
                                  sphoneerro("Phone number cannot be 0 or negative");
                                  // Clear the input if you want to prevent invalid input entirely
                                  e.target.value = "";
                                  setValidations(1);
                                }
                          validationCustom01"
                          autocomplete="off"
                          name="account_number"
                          value={data.account_number}
                          disabled={
                            state.NumberCounts.Editable == 1 &&
                            state.ClientBranchIDs.SUBROLE != 3
                              ? true
                              : false
                          }
                          readOnly={
                            state.NumberCounts.Editable == 1 &&
                            state.ClientBranchIDs.SUBROLE != 3
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            // if (e.target.value.length <= 8) {
                            //   setAccNumErr("*Account number must be more than 8 digits.");
                            //   setValidated(1)
                            // } else {
                            //   setAccNumErr("");
                            //   setValidated(0)
                            // }

                            
                            // HandleChanges(e);
                            // // setAccNumErr("");
                            const inputValue = e.target.value;
                            if (inputValue.length > 100) {
                              setAccNumErr("*Account number must not exceed 100 digits.");
                              setValidated(1);
                            } else if (inputValue.length <= 8) {
                              setAccNumErr("*Account number must be more than 8 digits.");
                              setValidated(1);
                            } else {
                              setAccNumErr("");
                              setValidated(0);
                            }
                            HandleChanges(e);
                      
                          }}
                        /> */}
                        <input
                          type="number"
                          // step="1"
                          ref={inputRef}
                          onKeyDown={(evt) => {
                            preventZoom(evt);
                          }}
                          onPaste={(evt) => handlePaste(evt)} // Handle pasting
                          onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel
                          className="form-control"
                          id="validationCustom01"
                          autoComplete="off"
                          name="account_number"
                          value={data.account_number}
                          disabled={
                            // state.NumberCounts.Editable == 1 && EmailID != "admin@gmail.com" ? true :
                            // state.ClientBranchIDs.SUBROLE == 3 &&state.NumberCounts.Editable == 1  && PennyDropVerification == false  ?
                            // false :state.NumberCounts.Editable == 2 && PennyDropVerification == false ? false:
                            // PennyDropVerification == true ? true :false
                            state.NumberCounts.Editable == 1 &&
                              EmailID != "admin@gmail.com" &&
                              EmailID != "admin@qpms.in"
                              ? true
                              : state.ClientBranchIDs.SUBROLE == 3 &&
                                state.NumberCounts.Editable == 1 &&
                                PennyDropVerification == false
                                ? false
                                : PennyDropVerification == true &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "admin@qpms.in"
                                  ? true
                                  : false
                          }
                          readOnly={
                            state.NumberCounts.Editable == 1 &&
                              EmailID != "admin@gmail.com" &&
                              EmailID != "admin@qpms.in"
                              ? true
                              : state.ClientBranchIDs.SUBROLE == 3 &&
                                state.NumberCounts.Editable == 1 &&
                                PennyDropVerification == false
                                ? false
                                : PennyDropVerification == true &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "admin@qpms.in"
                                  ? true
                                  : false
                          }
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            // if (inputValue <= 0) {
                            //   setAccNumErr("*Account number must be greater than 0.");
                            //   setValidated(1);
                            //   e.target.value = "";
                            // }
                            if (inputValue.length > 100) {
                              setAccNumErr(
                                "*Account number must not exceed 100 digits.",
                              );
                              setValidated(1);
                            } else if (inputValue.length <= 7) {
                              setAccNumErr(
                                "*Account number must be at least 8 digits.",
                              );
                              setValidated(1);
                            } else {
                              setAccNumErr("");
                              setValidated(0);
                            }
                            HandleChanges(e);
                          }}
                        />

                        <p className="Error" style={{ marginLeft: "-5px" }}>
                          {AcNumberErr}
                        </p>
                      </div>

                      <div className="col-sm-3 mt-3">
                        <label for="validationCustom01" class="form-label">
                          Phone Number
                        </label>
                        <div className="BankPhoneNum">
                          <input
                            type="number"
                            ref={inputRef}
                            // onKeyDown={(evt) =>
                            //   ["e", "E", "+", "-"].includes(evt.key) &&
                            //   evt.preventDefault()
                            // }
                            step="1"
                            onKeyDown={preventZoom} // Prevent zoom and unwanted keys
                            onPaste={handlePaste} // Handle pasting
                            onWheel={preventZoom} // Prevent zooming with the mouse wheel
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="phone_number"
                            value={PhoneNumber.phone_number}
                            onChange={(e) => {
                              const value = e.target.value;

                              // Regular expression to validate phone number
                              const phoneRegex = /^[1-9][0-9]{0,9}$/;
                              setPhoneErr("");
                              // Check if value exceeds 10 digits or is invalid
                              if (
                                value.length <= 10 &&
                                (phoneRegex.test(value) || value === "")
                              ) {
                                setPhoneNumber({
                                  ...PhoneNumber,
                                  phone_number: e.target.value,
                                });
                              }
                            }}
                          />

                          {
                            // state.pennydropforBank.BankVerify === false
                            PennyDropVerification == false ||
                              EmailID == "admin@gmail.com" ||
                              EmailID == "admin@qpms.in" ? (
                              // PennyDropVerification
                              <button
                                className="ButtonCSS3"
                                disabled={(() => {
                                  const accountNumber =
                                    data.account_number || "";
                                  const accountNumberLength =
                                    accountNumber.toString().length;

                                  const isDisabled =
                                    accountNumberLength <= 7 ||
                                    PhoneNumber.phone_number === "" ||
                                    // data.account_holder_name === "" ||
                                    data.ifsc_code === "" ||
                                    isBankVerified ||
                                    data.account_number === "";
                                  return isDisabled;
                                })()}
                                onClick={() => {
                                  const phone = PhoneNumber?.phone_number
                                    ? PhoneNumber?.phone_number?.trim()
                                    : PhoneNumber?.phone_number;

                                  // ✅ Empty check
                                  if (!phone) {
                                    toast.error("Please enter phone number");
                                    return;
                                  }

                                  // ✅ Indian mobile validation (starts 6–9, 10 digits)
                                  if (!/^[6-9]\d{9}$/.test(phone)) {
                                    toast.error("Enter a valid mobile number");
                                    return;
                                  }

                                  incrementCount();

                                  const payload = {
                                    data: data,
                                    //  count:count,
                                    count: state.OnboardngCounts.bank_count,
                                    phone_number: PhoneNumber.phone_number,
                                  };
                                  dispatch(BankVerifyActions(payload));
                                  // dispatch(CreateResponse_store(true))
                                }}
                              >
                                Verify
                              </button>
                            ) : null
                          }
                        </div>

                        <p className="Error" style={{ marginLeft: "-5px" }}>
                          {phoneErr}
                        </p>
                      </div>
                      {/* 
                      <div className="col-sm-3 mt-3">
                        <label for="validationCustom01" class="form-label">
                          Remark
                        </label>
                        <div className="BankPhoneNum">
                          <input
                            type="text"
                            step="1"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="remarks"
                            disabled
                            value={data.remarks}
                          />
                        </div>
                      </div> */}
                    </div>
                    <div className="row">
                      {state.NumberCounts.Editable == 1 &&
                        state.ClientBranchIDs.SUBROLE != 3 &&


                        state.CasualApproveRequestDatas.Inquriy.bank_image !=
                        undefined ? (
                        <div className="col mt-3">
                          <div>
                            <label for="validationCustom01" class="form-label">
                              cheque leaf or Passbook
                            </label>
                            <input type="file" hidden />
                            <a
                              href={
                                state.CasualApproveRequestDatas.Inquriy.bank_image
                              }
                              target="blank"
                            >
                              <div
                                className="mb-2"
                                style={{ width: "274px", height: "202px" }}
                              >
                                <img
                                  src={
                                    state.CasualApproveRequestDatas.Inquriy.bank_image

                                  }
                                  //  format={state.EducationAction.EducationData.sscl_id.file_e
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    border: "4px solid #234492",
                                    borderRadius: "12px",
                                  }}
                                  alt="File Preview"
                                  readOnly
                                />
                              </div>
                            </a>
                            <Downloads_doc
                              url={
                                state.CasualApproveRequestDatas.Inquriy.bank_image

                              }
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>

                    {/* {state.NumberCounts.Editable == 2 ? null : 
<>
                      <div
                        style={{
                          textAlign: "end",
                          marginRight: "20px",
                          marginBottom: "15px",
                          display: "flex",
                          alignItems: "flex-end",
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                        className="IdVerificationsID"
                      >
                        <span className="otp-status">
                          <input
                            type="checkbox"
                            id="otpCheckbox"
                            checked={whatsApp}
                            readOnly
                          />
                          <label
                            htmlFor="otpCheckbox"
                            className="custom-checkbox"
                          ></label>
                          <span
                            className="otp-message"
                            style={{
                              color: "#0FA402",
                              marginLeft: "10px",
                              fontSize: "19px",
                            }}
                          >
                            {whatsApp
                              ? "A one rupee credit has been made to your bank account."
                              : "A one rupee credit has not been made to your bank account."}
                          </span>
                        </span>
                      </div>
                      </>

                    } */}
                  </div>

                  <>
                    {state.CasualApproveRequestDatas.Inquriy?.is_pending &&

                      <div
                        className="RoleButton"
                        style={{
                          display: "flex",
                          gap: "15px",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          padding: "0px 15px",
                          marginBottom: "20px",
                        }}
                      >
                        <button
                          class="btn ButtonCSS"
                          style={{ color: "#ffff", background: "#234492" }}
                          onClick={(e) => {
                            HandleSaveNext();
                          }}
                        >
                          Save & Continue
                        </button>
                      </div>}
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={Bankfile}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}
    </>
  );
};

export default CasualBankDetails;
